import { axiosInstance } from "../../utility/apiInstance";

export const fetchFlags = async (search = "") => {
  const trimmed = search.trim();
  const { data } = await axiosInstance.get("/api/v1/flags", {
    params: trimmed ? { search: trimmed } : {},
  });
  return data;
};

export const createFlag = async (payload: any) => {
  const { data } = await axiosInstance.post("/api/v1/flags", payload);
  return data;
};

export const updateFlag = async (payload: any) => {
  const { data } = await axiosInstance.put("/api/v1/flags", payload);
  return data;
};

export const fetchAttachedFlagCounts = async (id: any) => {
  const { data } = await axiosInstance.get(`/api/v1/flags/all-attached-flag/${id}`);
  return data;
};

export const setFlagStatus = async (id: number, status: boolean) => {
  const { data } = await axiosInstance.put(`/api/v1/flags/${id}`, { status });
  return data;
};